import {mapLegacyPagination} from '@/store/utils'
import * as mutationTypes from './mutation-types'
import api from '@/store/api/cancellation'
// Modules
import cancellation from './cancellation'
import summary from './summary'

const initialState = () => ({
    cancellations: {
        data: [],
        pagination: {}
    }
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        cancellations: state => state.cancellations.data,
        pagination: state => state.cancellations.pagination
    },
    actions: {
        /**
         * @param {{}} params
         * @returns {Promise<*>}
         */
        listCancellations: async ({commit, dispatch}, params) => {
            try {
                const response = await api.listCancellations(params)
                const cancellations = {
                    ...response,
                    pagination: mapLegacyPagination(response.pagination)
                }
                commit(mutationTypes.SET_CANCELLATIONS, cancellations)
                return cancellations
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetCancellations: ({commit}) => commit(mutationTypes.RESET_CANCELLATIONS)
    },
    modules: {
        cancellation,
        summary
    },
    mutations: {
        [mutationTypes.RESET_CANCELLATIONS]: (state) => Object.assign(state, initialState()),
        [mutationTypes.SET_CANCELLATIONS]: (state, data) => state.cancellations = data
    }
}
